export default "__VITE_ASSET__2c47948d__"